import { Swiper } from 'swiper';
import { Navigation, Pagination, EffectFade } from 'swiper/modules';

const getNavigationSettings = (slider) => {
	const sliderWrapper = slider.parentElement;
	const prevEl = sliderWrapper?.querySelector('.swiper-button-prev');
	const nextEl = sliderWrapper?.querySelector('.swiper-button-next');

	if (!prevEl || !nextEl) {
		return false;
	}

	return {
		prevEl,
		nextEl,
		lockClass: 'block-testimonial__swiper-button-lock',
	};
};

const sliders = document.querySelectorAll(
	'.acf-block:not(.block-testimonial-cards):not(.block-testimonial-image) .block-testimonials .swiper'
);

if (sliders.length > 0) {
	sliders.forEach((slider, index) => {
		slider.parentElement.classList.add(
			`block-testimonials__swiper--${index}`
		);

		const slides = slider.querySelectorAll('.block-testimonial');

		// Add unique class to each slide within the slider
		slides.forEach((slide, slideIndex) => {
			slide.classList.add(
				`block-testimonial__swiper--${index}-${slideIndex}`
			);
		});

		const paginationSelectors =
			slider.parentElement.querySelector('.swiper-pagination');

		const settings = {
			loop: true,
			grabCursor: true,
			watchOverflow: false,
			spaceBetween: 32,
			slidesPerView: 1,
			modules: [Navigation, Pagination, EffectFade],
			navigation: getNavigationSettings(slider),
			pagination: {
				el: paginationSelectors,
				clickable: true,
				dynamicBullets: true,
				dynamicMainBullets: 5,
			},
		};

		new Swiper(slider, settings);
	});
}
const imgSliders = document.querySelectorAll(
	'.acf-block:not(.block-testimonial-cards).block-testimonial-image .block-testimonials .swiper'
);

if (imgSliders.length > 0) {
	imgSliders.forEach((slider, index) => {
		// Add a unique class to the parent element for navigation
		slider.parentElement.classList.add(
			`block-testimonials__swiper--${index}`
		);

		const paginationSelectors =
			slider.parentElement.querySelector('.swiper-pagination');

		const settings = {
			loop: true,
			grabCursor: true,
			spaceBetween: 0,
			slidesPerView: 1,
			slidesPerGroup: 1,
			watchOverflow: false,
			autoHeight: true,
			modules: [Navigation, Pagination, EffectFade],
			fadeEffect: {
				crossFade: true,
			},
			effect: 'fade',
			navigation: getNavigationSettings(slider),
			pagination: {
				el: paginationSelectors,
				clickable: true,
				dynamicBullets: true,
				dynamicMainBullets: 5,
			},
			breakpoints: {
				768: {
					autoHeight: false,
				},
			},
			on: {
				init() {
					if (!window.matchMedia('(min-width: 768px)').matches) {
						return;
					}

					setTimeout(() => {
						// Recalculate the heights after Swiper is initialized
						const slides =
							slider.querySelectorAll('.block-testimonial');
						let maxHeight = 0;

						// Find the largest height among all `.block-testimonial` elements
						slides.forEach((slide) => {
							const slideHeight = slide.offsetHeight; // Get the height of the slide
							if (slideHeight > maxHeight) {
								maxHeight = slideHeight;
							}
						});

						// Apply the maximum height to all `.block-testimonial` elements
						slides.forEach((slide) => {
							slide.style.height = `${maxHeight}px`;
						});
					}, 500);
				},
			},
		};
		// Initialize Swiper
		new Swiper(slider, settings);
	});
}
